export default {
  allowAlignment: true,
  allowVideoFile: true,
  autoCenter: ['initialHeading', 'image', 'button']
};